export const hasUnlimitedVersion = () =>
  process.env.REACT_APP_UI_LIMITED_VERSION !== 'true';
